<div class="card-header bg-light">
  <h4 class="card-title mb-0">
    <i class="far fa-file"></i>
    {{tituloModal}}
  </h4>
</div>
<div class="p-2 wrapper">
  <form #f="ngForm">
    <div class="row">
      <div class="col-md-4 mb-2">
        <label class="form-label">Nº da Constatação</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="numeroConstacacao" [ngModelOptions]="{standalone: true}"
               readonly>
      </div>
      <div class="col-md-4 mb-2">
        <label class="form-label">Associado à</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="numeroOsa" [ngModelOptions]="{standalone: true}"
               readonly>
      </div>

      <div class="col-md-4 mb-2">
        <label class="form-label">Nº da Nota de Auditoria</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="nNotaAuditoriaExecucao" [ngModelOptions]="{standalone: true}"
               readonly>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 mb-2">
        <label class="form-label">Responsável</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="nomeResponsavel" [ngModelOptions]="{standalone: true}"
               readonly>
      </div>
      <div class="col-md-4 mb-2">
        <label class="form-label">Status</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="statusDescricao" [ngModelOptions]="{standalone: true}"
               readonly>
      </div>
      <div class="col-md-4 mb-2">
        <label class="form-label">Avaliação</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="avaliacaoDescricao" [ngModelOptions]="{standalone: true}"
               readonly>
      </div>
    </div>

    <div class="col-md-12 mb-2">
      <label class="form-label">Título</label>
      <input type="text" class="form-control form-control-sm" [(ngModel)]="model.titulo" [ngModelOptions]="{standalone: true}"
             name="titulo" maxlength="100" readonly>
    </div>

    <div class="col-md-12 mb-2">
      <label class="form-label" for="descricaoConstatacao">Descrição da Constatação</label>
      <div class="form-control" [innerHTML]="model.descricaoConstatacao"
           style="min-height: 150px; max-height: 300px; overflow-y: auto;">
      </div>
    </div>

    <div class="col-md-12 mb-2">
      <div class="mat-elevation-z4">
        <table mat-table [dataSource]="dataSource" class="w-100" matSort matSortDisableClear>
          <tr mat-header-row *matHeaderRowDef="['arquivoConstatacao', 'acoesConstatacao']" class="bg-light"></tr>

          <ng-container matColumnDef="arquivoConstatacao">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Arquivos</th>
            <td mat-cell *matCellDef="let element">
              <small (click)="Download(element)" class="download" style="cursor: pointer; color: #007bff;">
                {{ element?.nomeArquivo }}
              </small>
            </td>
          </ng-container>

          <ng-container matColumnDef="acoesConstatacao">
            <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 100px;">Ações</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <button type="button" class="btn btn-info btn-xs" (click)="Download(element)"
                      title="Download">
                <i class="fas fa-download"></i>
              </button>
            </td>
          </ng-container>

          <tr mat-row *matRowDef="let row; columns: ['arquivoConstatacao', 'acoesConstatacao']"></tr>
        </table>
        <h5 [hidden]="dataSource?.data?.length > 0" class="table-no-data">
          Nenhum anexo encontrado
        </h5>
        <mat-paginator #tabelaItemPaginator [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
        </mat-paginator>
      </div>
    </div>

    <div class="col-md-12 mb-2">
      <label class="form-label" for="descricaoRecomendacao">Descrição da Recomendação</label>
      <div class="form-control" [innerHTML]="model.descricaoRecomendacao"
           style="min-height: 150px; max-height: 300px; overflow-y: auto;">
      </div>
    </div>

    <div class="col-md-12 mb-2">
      <label class="form-label" for="descricaoResposta">Descrição da Resposta</label>
      <angular-editor
        *ngIf="!visualizar; else visualizarResposta"
        [config]="config"
        id="descricaoResposta"
        rows="40"
        [(ngModel)]="respostaItemModel.descricao"
        [ngModelOptions]="{standalone: true}"
        (ngModelChange)="onEditorChange($event)"
        [ngClass]="{ 'is-invalid': submitted && !respostaItemModel.descricao }">
      </angular-editor>
      <ng-template #visualizarResposta>
        <div class="form-control" [innerHTML]="respostaItemModel.descricao"
             style="min-height: 150px; max-height: 300px; overflow-y: auto;">
        </div>
      </ng-template>
      <div *ngIf="submitted && !respostaItemModel.descricao" class="invalid-feedback d-block">
        <div>Campo obrigatório</div>
      </div>
    </div>
  </form>

  <div class="col-md-12">
    <div class="mat-elevation-z4">
      <table mat-table [dataSource]="dataSourceResposta" class="w-100" matSort matSortDisableClear>
        <tr mat-header-row *matHeaderRowDef="['arquivo', 'acoes']" class="bg-light"></tr>
        <ng-container matColumnDef="arquivo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Arquivos da Resposta</th>
          <td mat-cell *matCellDef="let element">
            <small (click)="DownloadResposta(element)" class="download" style="cursor: pointer;">
              {{ element?.nomeArquivo }}
            </small>
          </td>
        </ng-container>
        <ng-container matColumnDef="acoes">
          <th mat-header-cell *matHeaderCellDef class="text-right">
          <span *ngIf="!visualizar">
            <label for="file" class="btn btn-success btn-xs mb-0"> Adicionar</label>
            <input type="file" id="file" name="file[]" multiple="multiple" style="display: none"
                   [accept]="acceptTypes" (change)="anexarArquivosResposta($event)" />
          </span>
          </th>
          <td mat-cell *matCellDef="let element; let i = index" class="text-center">
            <button type="button" class="btn btn-danger btn-xs mr-1" (click)="removerArquivoItemResposta(element)"
                    *ngIf="!visualizar" title="Excluir">
              <i class="far fa-trash-alt"></i>
            </button>
            <button type="button" class="btn btn-info btn-xs" (click)="DownloadResposta(element)"
                    title="Download">
              <i class="fas fa-download"></i>
            </button>
          </td>
        </ng-container>
        <tr mat-row *matRowDef="let row; columns: ['arquivo', 'acoes']"></tr>
      </table>
      <h5 [hidden]="dataSourceResposta?.data?.length > 0" class="table-no-data">
        Nenhum registro encontrado
      </h5>
      <mat-paginator #tabelaRespostaPaginator [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
      </mat-paginator>
    </div>

    <!-- ✅ MENSAGEM DE VALIDAÇÃO PARA ARQUIVOS -->
    <div *ngIf="submitted && (!dataSourceResposta?.data || dataSourceResposta.data.length === 0)"
         class="invalid-feedback d-block mt-1">
      <div>É necessário anexar pelo menos um arquivo</div>
    </div>
  </div>
</div>
<div class="card-footer">
  <div class="d-flex w-100 justify-content-between align-items-center">
    <div class="list2">
      <div class="btn-group" [hidden]="visualizar">
        <button class="btn btn-primary btn-sm mr" (click)="salvar(false)">
          <i class="far fa-save"></i> Salvar
        </button>
        <button type="button" class="btn btn-primary btn-sm mr-1 dropdown-toggle dropdown-icon"
                data-toggle="dropdown" aria-expanded="false"></button>
        <div class="dropdown-menu" role="menu">
          <a class="dropdown-item" (click)="salvar(false)">Salvar</a>
          <a class="dropdown-item" (click)="salvar(true)">Salvar e fechar</a>
        </div>
      </div>

      <button type="button" class="btn btn-default btn-sm mr-1" (click)="cancelar()">
        <i class="fas fa-times"></i> Fechar
      </button>
    </div>
    <div class="list1">

    </div>
  </div>
</div>
